import mean from 'lodash/mean';
import { notEmpty } from './functions';
export var Numeric;
(function (Numeric) {
    function clamp(number, lowerBound, upperBound) {
        if (number < lowerBound) {
            return lowerBound;
        }
        else if (upperBound !== undefined && upperBound < number) {
            return upperBound;
        }
        else {
            return number;
        }
    }
    Numeric.clamp = clamp;
    function stddev(array) {
        const avg = mean(array);
        return Math.sqrt(mean(array.filter(notEmpty).map((v) => (v - avg) * (v - avg))));
    }
    Numeric.stddev = stddev;
    function inRange(number, lowerBound, upperBound) {
        return lowerBound <= number && number < upperBound;
    }
    Numeric.inRange = inRange;
    function intAndFraction(n) {
        return [Math.floor(n), n % 1];
    }
    Numeric.intAndFraction = intAndFraction;
    function isPowerOfTwo(n) {
        return (Math.log(n) / Math.log(2)) % 1 === 0;
    }
    Numeric.isPowerOfTwo = isPowerOfTwo;
    function isInteger(n) {
        return Math.round(n) == n;
    }
    Numeric.isInteger = isInteger;
    function gaussianRandom(mean, std) {
        const u1 = Math.random();
        const u2 = Math.random();
        const z0 = Math.sqrt(-2.0 * Math.log(u1)) * Math.cos(Math.PI * 2 * u2);
        //const z1 = Math.sqrt(-2.0 * Math.log(u1)) * Math.sin(_2PI * u2)
        return z0 * std + mean;
    }
    Numeric.gaussianRandom = gaussianRandom;
    function primeFactors(num) {
        const factors = [];
        for (let i = 2; i <= num; i++) {
            let p = 0;
            for (; (num % i) === 0; ++p)
                num /= i;
            if (p > 0)
                factors.push([i, p]);
        }
        return factors;
    }
    Numeric.primeFactors = primeFactors;
    function gcd(...values) {
        if (values.length == 0) {
            throw new Error('Empty array');
        }
        if (values.length == 1) {
            return values[0];
        }
        if (values.length == 2) {
            const [a, b] = values;
            return a ? gcd(b % a, a) : b;
        }
        return values.reduce((a, b) => gcd(a, b));
    }
    Numeric.gcd = gcd;
    function lcm(...values) {
        if (values.length == 0) {
            throw new Error('Empty array');
        }
        if (values.length == 1) {
            return values[0];
        }
        if (values.length == 2) {
            const [a, b] = values;
            return a * b / gcd(a, b);
        }
        return values.reduce((a, b) => lcm(a, b));
    }
    Numeric.lcm = lcm;
})(Numeric || (Numeric = {}));
//# sourceMappingURL=numeric.js.map